import React from 'react';
import LeaderboardSciFiPanel from './LeaderboardSciFiPanel';
import { useLeaderboard } from '../../state/useLeaderboard';
import { formatCompactNumber } from '../../utils/formatters';
import './LeaderboardSciFiPanel.css';

interface LeaderboardPanelProps {
  onClose: () => void;
  playerId?: string;
}

const LeaderboardPanel: React.FC<LeaderboardPanelProps> = ({ onClose, playerId }) => {
  const { entries, loading, error } = useLeaderboard();
  const getDisplayName = (entry: typeof entries[number]) => {
    const trimmed = entry.playerName?.trim();
    if (trimmed && trimmed.length > 0 && trimmed !== entry.playerId) {
      return trimmed;
    }
    return `${entry.playerId.slice(0, 8)}…`;
  };

  return (
    <LeaderboardSciFiPanel title="LEADERBOARD" onClose={onClose}>
      {loading ? (
        <div style={{ textAlign: 'center', padding: '1.2rem 0' }}>Loading leaderboard...</div>
      ) : error ? (
        <div style={{ color: '#ffb4e6', textAlign: 'center', padding: '1.2rem 0' }}>Error: {error}</div>
      ) : (
        <table className="scifi-leaderboard-table" style={{ width: '100%', fontFamily: 'var(--font-family, Arial, sans-serif)', fontSize: '1rem', background: 'none', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ width: 36, fontWeight: 700, fontSize: '1.05rem', letterSpacing: 1.2, color: '#a259e6', background: 'none', borderBottom: '2px solid #a259e6', fontFamily: 'var(--font-family, Arial, sans-serif)' }}>#</th>
              <th style={{ fontWeight: 700, fontSize: '1.05rem', color: '#a259e6', background: 'none', borderBottom: '2px solid #a259e6', fontFamily: 'var(--font-family, Arial, sans-serif)' }}>Player</th>
              <th style={{ width: 80, fontWeight: 700, fontSize: '1.05rem', color: '#a259e6', background: 'none', borderBottom: '2px solid #a259e6', fontFamily: 'var(--font-family, Arial, sans-serif)' }}>Prestige</th>
              <th style={{ width: 100, textAlign: 'right', fontWeight: 700, fontSize: '1.05rem', color: '#a259e6', background: 'none', borderBottom: '2px solid #a259e6', fontFamily: 'var(--font-family, Arial, sans-serif)' }}>Yield/s</th>
              <th style={{ width: 100, textAlign: 'right', fontWeight: 700, fontSize: '1.05rem', color: '#a259e6', background: 'none', borderBottom: '2px solid #a259e6', fontFamily: 'var(--font-family, Arial, sans-serif)' }}>Ore Mined</th>
            <th style={{ width: 100, textAlign: 'right', fontWeight: 700, fontSize: '1.05rem', color: '#a259e6', background: 'none', borderBottom: '2px solid #a259e6', fontFamily: 'var(--font-family, Arial, sans-serif)' }}>Total Score</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((entry, idx) => (
              <tr
                key={entry.playerId}
                className={playerId === entry.playerId ? 'current-player' : ''}
                style={{
                  background: playerId === entry.playerId ? '#a259e6' : 'none', // solid purple highlight
                  fontWeight: playerId === entry.playerId ? 700 : 400,
                  color: playerId === entry.playerId ? '#fff' : '#222',
                  borderRadius: 6,
                  fontSize: '1rem',
                  fontFamily: 'var(--font-family, Arial, sans-serif)',
                  transition: 'background 0.2s, color 0.2s',
                }}
              >
                <td style={{ width: 36, textAlign: 'right', opacity: 0.85 }}>{idx + 1}</td>
                <td style={{ paddingLeft: 12, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{getDisplayName(entry)}</td>
                <td style={{ textAlign: 'center' }}>{entry.prestigeLevel}</td>
                <td style={{ width: 100, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{Math.round(entry.yieldPerSecond).toLocaleString()} m³/s</td>
                <td style={{ width: 100, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{formatCompactNumber(entry.currentPrestigeScore)}</td>
                <td style={{ width: 100, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{formatCompactNumber(entry.totalScoreAllTime)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </LeaderboardSciFiPanel>
  );
};

export default LeaderboardPanel;
